<template>
  <div class="debt-order-list">
    <div class="header">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.order_sn" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="商品SKU">
          <el-input v-model="searchForm.goods_item" placeholder="请输入商品SKU" clearable></el-input>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="全部" :value="99"></el-option>
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="order_sn" label="订单号" width="180" align="center"></el-table-column>
        <el-table-column prop="goods_item" label="商品SKU" width="150" align="center"></el-table-column>
        <el-table-column prop="item_name" label="商品名称" min-width="250" align="center"></el-table-column>
        <el-table-column prop="order_num" label="订单数量" width="100" align="center"></el-table-column>
        <el-table-column prop="stock_num" label="库存数量" width="100" align="center"></el-table-column>
        <el-table-column prop="shortage_num" label="欠货数量" width="100" align="center">
          <template v-slot="{ row }">
            <span style="color: #f56c6c; font-weight: bold;">{{ row.shortage_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template v-slot="{ row }">
            {{ formatTimestamp(row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="处理状态" width="100" align="center">
          <template v-slot="{ row }">
            <el-tag :type="getStatusType(row.status)">{{ getStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" size="small" @click="handleDetail(row)">查看</el-button>
            <el-button type="text" size="small" @click="handlePurchase(row)" v-if="row.status === 0">采购</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="footer" v-if="tableData.length > 0">
      <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebtOrderList',
  data() {
    return {
      searchForm: {
        order_sn: '',
        goods_item: '',
        status: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$axios.get('/a1/shortage/list', {
        params: {
          page: this.pagination.page,
          page_size: this.pagination.pageSize,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.data.data.data || [];
        this.pagination.total = res.data.total || 0;
      }).catch(err => {
        console.error('获取欠单列表失败:', err);
        this.$message.error('获取数据失败');
      });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.loadData();
    },
    handleReset() {
      this.searchForm = {
        order_sn: '',
        goods_item: '',
        status: ''
      };
      this.pagination.page = 1;
      this.loadData();
    },
    handleDetail(row) {
      this.$message.info(`查看订单 ${row.order_sn} 商品 ${row.goods_item} 的详情`);
    },
    handlePurchase(row) {
      this.$confirm(`确认对商品 ${row.goods_item} 发起采购申请？欠货数量：${row.shortage_num}`, '采购确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //this.$message.success(`已发起采购申请：${row.item_name}，数量：${row.shortage_num}`);
        this.$axios.post('/a1/shortage/verify', {
          ids: [row.id],
        }).then(res => {
          // if (res.data.code === 0) {
          //   this.$message.success('采购申请已发起');
          //   this.loadData();
          // } else {
          //   this.$message.error(res.data.msg || '采购申请发起失败');
          // }
          this.$message.success('采购申请已发起');
          this.loadData();
        }).catch(err => {
          this.$message.error('采购申请发起失败');
        });
      }).catch(() => {
        this.$message.info('已取消采购申请');
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadData();
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    getStatusType(status) {
      const statusMap = {
        0: 'warning',
        1: 'success'
      };
      return statusMap[status] || '';
    },
    getStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已完成',
      };
      return statusMap[status] || '未知';
    }
  }
}
</script>

<style scoped lang="scss">
.debt-order-list {
  margin: 20px;
  
  .header {
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    
    .search-form {
      margin-bottom: 0;
    }
  }
  
  .content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
  }
  
  .footer {
    margin-top: 20px;
    text-align: right;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
  }
}
</style>